<template>
  <div>
    <i18n v-if="config" :path="config.path">
      <template v-for="(value, elem) in config.slots" #[elem]>
        <b :key="`${elem}-slots`">{{ value }}</b>
      </template>
    </i18n>
  </div>
</template>

<script>
export default {
  name: "LogsLabel",
  props: {
    folderLogs: {
      type: Object,
      required: true,
    },
  },

  computed: {
    config() {
      const action = this.folderLogs.action;
      const d = this.folderLogs.actionDisplayLogs;
      const status = this.folderLogs?.data?.status;
      return this.getConfig(action, d, status);
    },
  },

  methods: {
    getConfig(action, d, status) {
      const map = {
        // creation dossier
        CREATE_FOLDER: {
          path: "folder.logs.folderCreate",
          slots: {
            folderName: d.folderName,
            collaboratorName: d.collaboratorName,
          },
        },

        // email cosmoform
        SUBMIT_COSMOFORM_EMAIL: {
          path: "folder.logs.cosmoformEmail",
          slots: {
            collaboratorEmail: d.clientEmail,
            cosmoForm: d.formular,
            collaboratorName: d.collaboratorName,
          },
        },

        // sms cosmoform
        SUBMIT_COSMOFORM_SMS: {
          path: "folder.logs.cosmoformSMS",
          slots: {
            collaboratorNumber: d.clientNumber,
            cosmoForm: d.formular,
            collaboratorName: d.collaboratorName,
          },
        },

        // answered cosmoform
        COSMOFORM_ANSWERED: {
          path: "folder.logs.cosmoformAnswered",
          slots: {
            cosmoForm: d.formular,
            collaboratorName: d.collaboratorName,
          },
        },

        // assignation de collaborateur
        ASSIGN_COLLABORATOR: {
          path: "folder.logs.assignCollaborator",
          slots: {
            assignedName: d.assignedName,
            collaboratorName: d.collaboratorName,
            folderName: d.folderName,
          },
        },

        // consentement record
        NEW_RECORD: {
          path: "folder.logs.newRecord",
          slots: {
            collaboratorName: d.collaboratorName,
            courseName: d.courseName,
          },
        },

        // demande d'information
        REQUEST_INFORMATION: {
          path: "folder.logs.requestInformation",
          slots: {
            assignedName: d.assignedName,
            courseName: d.courseName,
            collaboratorName: d.collaboratorName,
          },
        },

        // demande d'info sur une donnée (update answer validation)
        UPDATE_ANSWER_VALIDATION: this.getUpdateAnswerValidation(d, status),

        // lancement signature
        SIGNATURE_REQUEST: {
          path: "folder.logs.signatureRequest",
          slots: {
            collaboratorName: d.collaboratorName,
          },
        },

        // signature signée
        SIGNATURE_SIGNED: {
          path: "folder.logs.signatureSigned",
          slots: {
            collaboratorName: d.collaboratorName,
            clientName: d.client,
          },
        },

        // creation custom field
        CREATE_CUSTOM_FIELD: {
          path: "folder.logs.createCSField",
          slots: {
            fieldName: d.fieldName,
            collaboratorName: d.collaboratorName,
          },
        },

        // réponse custom field
        ANSWER_CUSTOM_FIELD: {
          path: "folder.logs.cSFieldAnswered",
          slots: {
            fieldName: d.fieldName,
            collaboratorName: d.collaboratorName,
          },
        },

        // modification custom field
        MODIFIED_CUSTOM_FIELD: {
          path: "folder.logs.modifyCSField",
          slots: {
            fieldName: d.fieldName,
            collaboratorName: d.collaboratorName,
          },
        },

        // changement de status
        STATUS_CHANGE: {
          path: "folder.logs.statusChange",
          slots: {
            statusFrom: d.statusFrom,
            statusTo: d.statusTo,
            collaboratorName: d.collaboratorName,
          },
        },

        // generation pdf
        GENERATE_PDF: {
          path: "folder.logs.generatePdf",
          slots: {
            collaboratorName: d.collaboratorName,
          },
        },

        // submission folder cosmoform
        SUBMIT_COSMOFORM: {
          path: "folder.logs.cosmoformSubmission",
          slots: {
            emailClient: d.clientEmail,
            collaboratorName: d.collaboratorName,
            questions: d.questions,
          },
        },

        // relaunch cosmoform
        RELAUNCH_CLIENT: {
          path: "folder.logs.relaunchClient",
          slots: {
            emailClient: d.clientEmail,
            collaboratorName: d.collaboratorName,
          },
        },

        // generation pdf (document signé)
        SIGNED_DOCUMENT: {
          path: "folder.logs.signedDocument",
          slots: {
            folderName: d.folderName,
          },
        },

        // document refusé
        REFUSED_DOCUMENT: {
          path: "folder.logs.signedDocument",
          slots: {
            folderName: d.folderName,
            collaboratorName: d.clientEmail,
          },
        },

        // dossier archivé
        FOLDER_ARCHIVED: {
          path: "folder.logs.archivedFolders",
          slots: {
            collaboratorName: d.collaboratorName,
          },
        },

        // dossier désarchivé
        FOLDER_UNARCHIVED: {
          path: "folder.logs.unArchivedFolders",
          slots: {
            collaboratorName: d.collaboratorName,
          },
        },
      };

      return map[action] || null;
    },

    getUpdateAnswerValidation(d, status) {
      if (status === "UPDATE_REQUESTED") {
        return {
          path: "folder.logs.updateValidationRequested",
          slots: {
            assigned: d.assigned,
            questions: d.questions,
            collaboratorName: d.collaboratorName,
          },
        };
      }

      if (status === "VALIDATED") {
        return {
          path: "folder.logs.answerValidated",
          slots: {
            questions: d.questions,
            collaboratorName: d.collaboratorName,
          },
        };
      }

      return {
        path: "folder.logs.answerRequestInformation",
        slots: {
          assigned: d.assigned,
          questions: d.questions,
        },
      };
    },
  },
};
</script>

<style scoped lang="scss">
.user_action {
  text-transform: capitalize;
  margin: 0 2px;
}
</style>
